/**
 * @group Contact
 * @summary Company phone unformatted
 * 
 * @remarks
 * This constant contains the unformatted company phone number used for
 * creating clickable phone links and API integrations.
 * 
 * @example
 * ```typescript
 * import { COMPANY_PHONE_UNFORMATTED } from '@shared/constants';
 * 
 * const telLink = `tel:${COMPANY_PHONE_UNFORMATTED}`;
 * ```
 */
export const COMPANY_PHONE_UNFORMATTED = "0215650416"; 